import type { ResultType } from '@ps/isp-web-services-types';
import React from 'react';

import { Icon } from '@swf/sports/components';
import type { IconName } from '@swf/sports/types/icon';

import styles from './ResultIcon.scss';

interface Props {
  result: ResultType;
}

const iconType: Partial<Record<ResultType, IconName>> = {
  WON: 'my-bets-win',
  LOST: 'my-bets-lose',
  PLACED: 'my-bets-placed',
  CASHED_OUT: 'my-bets-placed',
  VOID: 'my-bets-void'
};

const ResultIcon: React.FC<Props> = ({ result }) => (
  <span className={styles.wrapper}>
    <Icon name={iconType[result] ?? 'my-bets-placed'} size="xl" />
  </span>
);

export default ResultIcon;
